const AcademiaToolTip = ({
  active,
  payload,
}: {
  active: any;
  payload: any;
}) => {
  // rendering custom tooltip component here
  if (active && payload && payload.length) {
    return (
      <div className='bg-gray-300/35 p-2 rounded-md'>
        <p className='label'>{`${payload[0].name} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};

export default AcademiaToolTip;
